// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-datetime {
  margin: 0 auto;
  background: #f8f9fb;
}

.date-content {
  width: 100%;
  float: none;
  z-index: 9;
}

.time-content {
  width: 100%;
  float: none;
}

.label-date {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.label-time {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.buttonPWA {
  display: none;
}

.buttonMobile {
  display: block;
}

ion-button {
  --border-radius: 8px !important;
  height: 3vw !important;
  min-height: 3vw;
}

@media (min-width: 960px) {
  .label-date {
    display: none;
  }
  .label-time {
    display: none;
  }
  .time-content {
    width: 50%;
  }
  .time-pwa {
    padding-top: 12%;
  }
  .buttonPWA {
    display: block;
  }
  .buttonMobile {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/custom-date-popover/custom-date-popover.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,+BAAA;EACA,sBAAA;EACA,eAAA;AACJ;;AAGA;EACI;IACI,aAAA;EAAN;EAEE;IACI,aAAA;EAAN;EAQE;IACI,UAAA;EANN;EAUE;IACI,gBAAA;EARN;EAWE;IACI,cAAA;EATN;EAYE;IACI,aAAA;EAVN;AACF","sourcesContent":["ion-datetime{\n    margin: 0 auto;\n    background: #f8f9fb;\n}\n\n.date-content{\n    width: 100%;\n    float: none;\n    z-index: 9;\n}\n\n.time-content{\n    width: 100%;\n    float: none;\n}\n\n.label-date{\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.label-time{\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.buttonPWA{\n    display: none;\n}\n\n.buttonMobile{\n    display: block;\n}\n\nion-button{\n    --border-radius: 8px !important;\n    height: 3vw !important;\n    min-height: 3vw;\n}\n\n//PWA\n@media (min-width: 960px) {\n    .label-date{\n        display: none;\n    }\n    .label-time{\n        display: none;\n    }\n\n    .date-content{\n        //width: 50%;\n        //float: left;\n    }\n    \n    .time-content{\n        width: 50%;\n        //float: right;\n    }\n\n    .time-pwa{\n        padding-top: 12%;\n    }\n\n    .buttonPWA{\n        display: block;\n    }\n\n    .buttonMobile{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
